<section
  class="centered-with-padding grid h-fit grid-cols-1 items-center gap-x-12 gap-y-4 py-7 desk:grid-cols-[auto_1fr]">
  <div>
    <app-title [title]="data.title" size="h1" />
    <div [innerHTML]="data.description" class="prose mt-5" handleHtmlLinks></div>
  </div>
  @let video = data.video;
  @let isVideo = video | isVideo;
  <div class="aspect-video overflow-hidden rounded-3xl">
    @if (isVideo) {
      <app-video [isImagePriority]="!isImageInPreviousBlocks" [keepAspectRatio]="true" [video]="video" />
    } @else if (video | isVideoYoutube) {
      <app-youtube-player [videoId]="video.link | youtubeIdExtractor" />
    }
  </div>
</section>
